import InfoCard from "../InfoCard";

/**
 * Wrapper component for InfoCard with conditional rendering logic
 * @param {Object} props - Component props
 * @param {boolean} props.isShown - Whether the info card should be shown
 * @param {boolean} props.hasMatches - Whether there are matches for the selected date
 * @param {Function} props.onClose - Handler for closing the info card
 * @param {Function} props.onPlayPress - Handler for play button press
 * @param {Function} props.onPrizesPress - Handler for prizes button press
 * @returns {JSX.Element|null} - InfoCard or null if conditions not met
 */
const InfoCardWrapper = ({ isShown, hasMatches, onClose, onPlayPress, onPrizesPress }) => {
	// Only show if both conditions are met
	if (!isShown || !hasMatches) {
		return null;
	}

	return <InfoCard onClose={onClose} onButtonPress={onPlayPress} onPrizesButtonPress={onPrizesPress} />;
};

export default InfoCardWrapper;
